{
  "(optional)": "(opcionalno)",
  "(required)": "(obvezno)"
}
